export default __webpack_public_path__ + "static/Konditor Seite 3-470c625c2b172bb5525c8b388cf9906f.jpg";